import { render, staticRenderFns } from "./Tills.vue?vue&type=template&id=235bbca2&"
import script from "./Tills.vue?vue&type=script&lang=js&"
export * from "./Tills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports